import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tree-view-item',
  templateUrl: './tree-view-item.component.html',
  styleUrls: ['./tree-view-item.component.css']
})
export class TreeViewItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
